import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { FaTruckMoving, FaCarSide, FaPlusCircle, FaMapMarkerAlt } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Avatar } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import apiClient from "../api/apiClient";

export default ({ user, vehicle, values }) => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);
  const userId = useSelector((state) => state?.auth?.userId);

  const [image, setimg] = useState();
  const { profile_url, setProfile_url } = values;
  useEffect(() => {
    const handleResize = () => {
      const mobileWidth = 950;
      setIsMobile(window.innerWidth < mobileWidth);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const ProfileHandelChange = async (e) => {
    const file = e.target.files[0];
    setProfile_url(file);

    const formData = new FormData();
    formData.append("profile_url", file);
    setimg("");

    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        throw new Error("Authentication token not found");
      }

      const res = await apiClient.patch(
        `/authentication/accounts/${userId}/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast.success("Profile picture updated successfully");
      fetch();
    } catch (error) {
      console.error("Error updating profile picture:", error);
      toast.error("Failed to update profile picture");
    }
  };

  const [status, setstatus] = useState(false);
  const navigate = useNavigate();

  const fetch = async () => {
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        throw new Error("Authentication token not found");
      }
      const res = await apiClient.get(`/authentication/accounts/`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setimg(res?.data?.profile_url);
      // toast.success("Profile information fetched successfully");
    } catch (error) {
      console.error("Error fetching profile information:", error);
      toast.error("Failed to fetch profile information");
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  return (
    <div>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="ps-0 ps-md-3  ">
        s
        <div
          className=""
          style={{
            backgroundColor: "#015A96",
            borderTopLeftRadius: 20,
            borderBottomLeftRadius: 20,
          }}
        >
          {(status || !isMobile) && (
            <div
              className=" sidebar"
              style={{ height: "95vh", overflow: "auto" }}
            >
              <div className="side-bar-content pt-5 d-flex flex-wrap flex-column align-items-center">
                <div className="  profile_img">
                  <div
                    style={{ width: "5rem" }}
                    className=" img pb-2  border border-2 border-top-0 border-end-0 border-start-0 border-white"
                  >
                    {/* <CircularProgress /> */}
                    <Avatar
                      sx={{ height: 82, width: 82 }}
                      src={image || require("../assets/img/account-icon.png")}
                    />
                  </div>

                  <input
                    hidden
                    type="file"
                    name=""
                    id="uplod-profile"
                    onChange={ProfileHandelChange}
                  />
                  <label htmlFor="uplod-profile">
                    <FaPlusCircle className="img_icon" />
                  </label>
                </div>

                <div className="sidebar-links">
                  <ul className="list-unstyled sidebar_list  p-2">
                    <NavLink
                      className="text-white nav-link  "
                      to={"/vehicleowneraccount"}
                    >
                      <li
                        className="m-2 p-2"
                        onClick={() => {
                          setstatus(false);
                          // navigate('/vehicleowneraccount')
                        }}
                      >
                        <i className="bi bi-person-fill " />
                        <span className="ps-2 fs-5">Account</span>
                      </li>
                    </NavLink>

                    <NavLink
                      className={`text-white nav-link ${
                        location.pathname === "/vehicleowneraddvehicle"
                          ? "active"
                          : ""
                      }`}
                      to={"/vehicleownervehicle"}
                    >
                      <li
                        className="m-2 p-2"
                        onClick={() => {
                          setstatus(false);
                          // navigate('/vehicleownervehicle')
                        }}
                      >
                        <FaCarSide />
                        <span className="ps-2 fs-5">Vehicles</span>
                      </li>
                    </NavLink>

                    <NavLink
                      className=" text-white nav-link d-flex align-items-center"
                      to={"/vehicleownerpayment"}
                    >
                      <li
                        className="m-2 mt-1 p-2"
                        onClick={() => {
                          setstatus(false);
                          navigate("/vehicleownerpayment");
                        }}
                      >
                        <i className="bi bi-credit-card-fill" />
                        <span className="ps-2 fs-5">Payment</span>
                      </li>
                    </NavLink>

                    <NavLink
                      className="text-white nav-link"
                      to={"/vehicleownercampaigns"}
                    >
                      <li
                        className=" m-2 p-2"
                        onClick={() => {
                          setstatus(false);
                        }}
                      >
                        <FaTruckMoving />
                        <span className="ps-2 fs-5 ">Campaigns</span>
                      </li>
                    </NavLink>

                    <NavLink
                      className="text-white nav-link d-flex align-items-center"
                      to={"/vehicleowner-live-monitor"}
                    >
                      <li
                        className="m-2 p-2"
                        onClick={() => {
                          setstatus(false);
                        }}
                      >
                        <FaMapMarkerAlt />
                        <span className="ps-2 fs-5">Live drivers</span>
                      </li>
                    </NavLink>

                    <NavLink
                      className="text-white d-flex align-items-center nav-link"
                      to={"/vehicleowner-request"}
                    >
                      <li
                        className="m-2 mt-1 p-2"
                        onClick={() => {
                          setstatus(false);
                          // navigate('/vehicleowner-request')
                        }}
                      >
                        <i className="bi bi-chat-left-fill" />
                        <span className="ps-2 fs-5">Requests</span>
                      </li>
                    </NavLink>

                    <NavLink
                      className="text-white d-flex align-items-center nav-link"
                      to={"/vehicle-owner-schedule"}
                    >
                      <li
                        className="m-2 mt-1 p-2"
                        onClick={() => {
                          setstatus(false);
                          // navigate('/vehicle-owner-schedule')
                        }}
                      >
                        <i className="bi bi-calendar-fill" />
                        <span className="ps-2 fs-5">Schedule</span>
                      </li>
                    </NavLink>

                    <NavLink
                      className="text-white d-flex align-items-center nav-link"
                      to={"/vehicleownersetting"}
                    >
                      <li
                        className="setting m-2 mt-1 p-2"
                        onClick={() => {
                          setstatus(false);
                          // navigate('/vehicleownersetting')
                        }}
                      >
                        <i className="bi bi-gear-fill" />
                        <span className="ps-2 fs-5">Settings</span>
                      </li>
                    </NavLink>
                  </ul>
                </div>
              </div>
            </div>
          )}
          {isMobile && (
            <button
              style={{ zIndex: "999999" }}
              onClick={() => setstatus(!status)}
              className="open-menu d-block  ms-auto text-white fs-2 border-0 bg-blue rounded-pill p-3 position-absolute top-0 end-0"
            >
              <i className="bi bi-list" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
